/* eslint-disable prettier/prettier */
import { Injectable } from '@angular/core'
import firebase from "firebase"
import { BehaviorSubject } from 'rxjs'
import {
  FirestoreAccess,
  INFINITE_SCROLL_PAGE_SIZE,
} from 'src/lib/firestore-access'
import { PUBLIC_STATUS } from 'src/lib/constants'
import { Gift } from 'src/lib/entity/gift'
import { GiftMeta, LiveComment } from "src/lib/entity/live"

const date = new Date()

const initLatestComment = {
  id: '',
  liveId: '',
  userId: 0,
  status: undefined,
  userNickname: undefined,
  message: '',
  createdAt: firebase.firestore.Timestamp.fromDate(date),
  updatedAt: firebase.firestore.Timestamp.fromDate(date),
  giftMeta: undefined,
}

@Injectable({
  providedIn: 'root',
})
export class GiftService {
  private publicLastVisible: Gift
  private privateLastVisible: Gift
  private publicGiftsSubject = new BehaviorSubject<Gift[]>([])
  private privateGiftsSubject = new BehaviorSubject<Gift[]>([])
  publicGifts$ = this.publicGiftsSubject.asObservable()
  privateGifts$ = this.privateGiftsSubject.asObservable()
  loadingSubject = new BehaviorSubject<boolean>(false)
  loading$ = this.loadingSubject.asObservable()

  commentsSubject = new BehaviorSubject<LiveComment[]>([])
  latestCommentsSubject = new BehaviorSubject<LiveComment>(initLatestComment)
  giftMetaSubject = new BehaviorSubject<GiftMeta | null>(null)
  comments$ = this.commentsSubject.asObservable()
  latestComment$ = this.latestCommentsSubject.asObservable()
  giftMeta$ = this.giftMetaSubject.asObservable()

  constructor(
    private firestoreAccess: FirestoreAccess,
    ) {}

  loadMorePublicGifts = (
    pageSize: number = INFINITE_SCROLL_PAGE_SIZE,
    isScrolled: boolean = false
  ) => {
    this.loadingSubject.next(true)
    this.firestoreAccess
      .loadGifts(this.publicLastVisible, PUBLIC_STATUS.public, pageSize)
      .subscribe((data) => {
        const newLastVisible = data[data.length - 1]
        if(!isScrolled) {
          this.publicLastVisible = null
          this.publicGiftsSubject.next(data)
        } else {
          this.publicGiftsSubject.next([...this.publicGiftsSubject.getValue(), ...data])
        }
        this.publicLastVisible = newLastVisible
        this.loadingSubject.next(false)
      })
  }

  loadMorePrivateGifts = (
    pageSize: number = INFINITE_SCROLL_PAGE_SIZE,
    isScrolled: boolean = false
  ) => {
    this.loadingSubject.next(true)
    this.firestoreAccess
      .loadGifts(this.privateLastVisible, PUBLIC_STATUS.private, pageSize)
      .subscribe((data) => {
        const newLastVisible = data[data.length - 1]
        console.log(`data: ${JSON.stringify(data)}`)
        if(!isScrolled) {
          this.privateLastVisible = null
          this.privateGiftsSubject.next(data)
        } else {
          this.privateGiftsSubject.next([...this.privateGiftsSubject.getValue(), ...data])
        }
        this.privateLastVisible = newLastVisible
        this.loadingSubject.next(false)
      })
  }

  resetLastVisible = (isPrivate: boolean) => {
    if (isPrivate) {
      this.privateLastVisible = null
    } else {
      this.publicLastVisible = null
    }
  }
}